import React from 'react'
import { useDispatch } from 'react-redux'
import Button from 'components/Button'
import ConfirmModal from 'components/ConfirmModal'
import { addModal } from 'features/modals/modalSlice'
import { InviteTo } from 'generated/graphql'
import { useEventSlug } from 'hooks'
import { _ } from 'utils'
import { sendBatchEmails } from '../graphql/mutation'
import { StatusOverview } from '../tabs/Attendees'
import BulkInviteProgress from './BulkInviteProgress'
import { startCount } from '../attendeeSlice'

const InviteActionsTopToolbar = ({ statusOverview }: { statusOverview?: StatusOverview }) => {
    const dispatch = useDispatch()
    const eventSlug = useEventSlug()

    const showInviteConfirm = ({ onConfirm, title, description }) => {
        dispatch(addModal({
            Component: ({ close }: { close: () => void }) => (
                <ConfirmModal
                    close={close}
                    title={title}
                    confirmDescription={description}
                    variantConfirm="primary"
                    onConfirm={onConfirm}
                />
            ),
            shouldNotWrap: true
        }))
    }

    const handleSendBatchEmails = async (to: InviteTo, total: number) => {
        dispatch(startCount(total))
        await sendBatchEmails(eventSlug, to)
        dispatch(addModal({
            Component: ({ close: uploadingClose }: { close: () => void }) => (
                <BulkInviteProgress close={uploadingClose} />
            ),
            backdrop: 'static'
        }))
    }

    return (
        <>
            <Button
                variant="secondary"
                size="sm"
                className="mr-2"
                onClick={() => showInviteConfirm({
                    title: _('attendee.list.invite_to_all_title'),
                    description: _(
                        'attendee.list.invite_to_all_description', { value: statusOverview.total }
                    ),
                    onConfirm: () => (
                        handleSendBatchEmails(InviteTo.All, statusOverview.new + statusOverview.pending)
                    )
                })}
            >
                {_('attendee.list.invite_to_all_button')}
            </Button>
            <Button
                variant="secondary"
                size="sm"
                className="mr-2"
                onClick={() => showInviteConfirm({
                    title: _('attendee.list.invite_to_new_title'),
                    description: _('attendee.list.invite_to_new_description', { value: statusOverview.new }),
                    onConfirm: () => handleSendBatchEmails(InviteTo.New, statusOverview.new)
                })}
            >
                {_('attendee.list.invite_to_new_button')}
            </Button>
            <Button
                variant="secondary"
                size="sm"
                className="mr-2"
                onClick={() => showInviteConfirm({
                    title: _('attendee.list.invite_to_pending_title'),
                    description: _(
                        'attendee.list.invite_to_pending_description', { value: statusOverview.pending }
                    ),
                    onConfirm: () => handleSendBatchEmails(InviteTo.Pending, statusOverview.pending)
                })}
            >
                {_('attendee.list.invite_to_pending_button')}
            </Button>
        </>
    )
}

export default InviteActionsTopToolbar
